import * as React from 'react';

function obtainClassName(selected) {
  let className = 'qual-line';
  if (selected) {
    className += ' active';
  }
  return className;
}

export default function({ onClick, name, selected, id }) {
  return (
    <div>
      <a className={obtainClassName(selected)} onClick={onClick}>
        {name}
      </a>
    </div>
  );
}
